import { render, staticRenderFns } from "./surveys.vue?vue&type=template&id=b988f95c&scoped=true"
import script from "./surveys.vue?vue&type=script&lang=js"
export * from "./surveys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b988f95c",
  null
  
)

export default component.exports